export default __webpack_public_path__ + "static/media/twitter.e0e5da7c.svg";